import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar"
import Footer from "./components/footer";
import Home from "./portfolio/home";
import About from "./portfolio/about";
import Playground from "./portfolio/playground";
import Visuals from "./portfolio/visuals";


import CaseStudy1 from "./portfolio/casestudy1";
import CaseStudy2 from "./portfolio/casestudy2";
import CaseStudy3 from "./portfolio/casestudy3";
import CaseStudy4 from "./portfolio/casestudy4";


function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/playground" element={<Playground />} />
        <Route path="/visuals" element={<Visuals />} />


        <Route path="/case-study/industrialgas" element={<CaseStudy1 />} />
        <Route path="/case-study/cloudevolve" element={<CaseStudy2 />} />
        <Route path="/case-study/digiyatra" element={<CaseStudy3 />} />
        <Route path="/case-study/nest" element={<CaseStudy4 />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;